import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { sendPasswordReset, resetForgotPasswordForm }
  from 'actions/authActions';
import ForgotPasswordForm from './forgotPasswordForm';

@connect(
  state => ({auth: state.auth}),
  { sendPasswordReset, resetForgotPasswordForm }
)
export default class ForgotPassword extends Component {

  static propTypes = {
    auth: PropTypes.shape({
      passwordResetSent: PropTypes.bool.isRequired
    }).isRequired,
    sendPasswordReset: PropTypes.func.isRequired,
    resetForgotPasswordForm: PropTypes.func.isRequired
  }

  componentWillMount () {
    this.props.resetForgotPasswordForm();
  }

  handleSubmit (data) {
    data.url = window.location.origin + '/signin?email=' + encodeURIComponent(data.email);
    return this.props.sendPasswordReset(data);
  }

  render () {
    const { passwordResetSent } = this.props.auth;

    if (!passwordResetSent) {
      return <ForgotPasswordForm onSubmit={::this.handleSubmit}/>;
    } else {
      return (
        <div>
          <h2>Password Reset Email Sent</h2>
          <p>"Please check your email inbox, and if you don't see an email from us shortly, be sure to check your junk/spam folder.</p>
        </div>
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/auth/forgotPassword.jsx